import Image from "../../Image";
import LuminodeLogo from "../../LuminodeLogo";
import Partner from "./Partner";
import Subtitle from "../../Subtitle";
import AcmeCorp from "../../svg/SampleLogos/AcmeCorp";
import LightBox from "../../svg/SampleLogos/LightBox";
import Luminous from "../../svg/SampleLogos/Luminous";
import Segment from "../../svg/SampleLogos/Segment";
import DegenTax from '@/assets/images/DegenTax-Logo-Full-DarkBG.png';
import Guildfi from '@/assets/images/guildfi-logo.png';
import ZentrySvg from "../../svg/SampleLogos/ZentrySvg";
import ChartySvg from "../../svg/SampleLogos/ChartySvg";
import SpiritDao from '@/assets/images/spiritdao_2.png';
import BaseLogo from '@/assets/images/base-logo2.png';
import CoinbaseLogo from '@/assets/images/cb-logo2.png';
import CoinbaseWalletLogo from '@/assets/images/cbwallet-logo2.png';
import SliceLogo from '@/assets/images/slice-logo.png';
import DetourLogo from '@/assets/images/DETOUR.png';
import Perena from '@/assets/images/perena_good.png';
import NodeMerch from '@/assets/images/nodemerch.png';
import NodeTax from '@/assets/images/nodetax.png';
import { InfiniteScroll } from "../../InfiniteScroll/InfiniteScroll";

function OurPartners() {
  return (
    <div className="w-full xl:w-[1450px]">
      <InfiniteScroll>
        <Partner number={1} href={'https://twitter.com/GuildFiGlobal'} >
          <Image src={Guildfi} alt='' width={170} height={43} />
        </Partner>
        <Partner number={2} href={'https://twitter.com/ZentryHQ'} >
          <ZentrySvg />
        </Partner>
        <Partner number={3} href={'https://nodetax.com/'} >
          <Image src={NodeTax} alt='' width={170} height={43} />
        </Partner>
        <Partner number={4} href={'https://twitter.com/spiritDAO'} >
          <Image src={SpiritDao} alt='' width={120} height={25} />
        </Partner>
        <Partner number={5} href={'https://x.com/base'} >
          <Image src={BaseLogo} alt='' width={120} height={25} />
        </Partner>
        <Partner number={6} href={'https://x.com/coinbase'} >
          <Image src={CoinbaseLogo} alt='' width={120} height={25} />
        </Partner>
        <Partner number={7} href={'https://x.com/CoinbaseWallet'} >
          <Image src={CoinbaseWalletLogo} alt='' width={150} height={50} />
        </Partner>
        <Partner number={8} href={'https://x.com/slice__so'} >
          <Image src={SliceLogo} alt='' width={120} height={25} />
        </Partner>
        <Partner number={9} href={'https://x.com/ecodetour'} >
          <Image src={DetourLogo} alt='' width={160} height={50} />
        </Partner>
        <Partner number={10} href={'https://perena.org/'} >
          <Image src={Perena} alt='' width={120} height={25} />
        </Partner>
        <Partner number={11} href={'https://x.com/nodemerch'} >
          <Image src={NodeMerch} alt='' width={160} height={50} />
        </Partner>
      </InfiniteScroll>
    </div>
  );
}

export default OurPartners;